import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, UrlSegment, ActivatedRouteSnapshot, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class AuthenticationGuard  {

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (this.authenticationService.IsAuthenticated()) {
      return true;
    }
    this.router.navigate(['account'], { replaceUrl: true });
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authenticationService.IsAuthenticated()) {
        return true;
    }
    this.router.navigate(['account'], { replaceUrl: true });
  }
}
